/**
 * 风信SDK - SSR 兼容
 *
 * 服务端不加载 SDK（依赖 window）；客户端在模块被加载时自动预加载 SDK。
 */

import { isServer } from "./constant";

interface WindCallInstance {
  callApp: (config: any) => void;
  [key: string]: any;
}

// 服务端 / 加载失败时的空实现，仅保证 callApp 可调用不报错
const noopCallApp = (config: any) => {
  if (typeof config?.onFail === "function") {
    config.onFail(new Error("WindCall SDK not available"));
  }
};

const noopInstance: WindCallInstance = { callApp: noopCallApp };


let windCallInstance: WindCallInstance | null = null;
let loadPromise: Promise<WindCallInstance> | null = null;

async function getWindCallInstance(): Promise<WindCallInstance> {
  if (windCallInstance) return windCallInstance;
  if (isServer) return noopInstance;
  if (loadPromise) return loadPromise;

  loadPromise = (async (): Promise<WindCallInstance> => {
    try {
      const { WindCall } = await import("@mtfe/wind-call-sdk");
      const instance = new WindCall({
        appKey: "FH0J2OkE2InIQByk",
        key: "distribution-center",
        type: "meituan",
        devMode: false,
      }) as WindCallInstance;
      windCallInstance = instance;
      return instance;
    } catch (error) {
      console.error("[windcall] Failed to load WindCall SDK:", error);
      return noopInstance;
    }
  })();

  return loadPromise;
}

// 客户端环境：模块加载时自动预加载风信 SDK，首次跳转时无需再等
if (!isServer) {
  getWindCallInstance().then(() => {
    console.log("getAppInstance success by callApp");
  });
}

export default {
  callApp(config: any): void {
    getWindCallInstance()
      .then((instance) => {
        console.log("getAppInstance success by callApp");
        instance.callApp(config);
      })
      .catch((err) => {
        console.error("[windcall] callApp failed:", err);
        if (typeof config?.onFail === "function") {
          config.onFail(err);
        }
      });
  },
};
